<template>
  <div class="app-toggle" :class="{'active': toggleActive }">
    <label>
      <span class="value" :class="{'active': ! toggleActive }" @click="click(false)">intern</span>
      <span class="toggle" @click="click(toggleActive = !toggleActive)"></span>
      <span class="value" :class="{'active': toggleActive }" @click="click(true)">extern</span>
    </label>
  </div>
</template>

<script>
export default {
  name: "AppToggle",

  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },

  mounted() {
    this.toggleActive = this.active;
  },

  data() {
    return {
      toggleActive: false,
    }
  },

  methods: {
    click(active) {
      this.toggleActive = active;

      this.$emit('change', this.toggleActive);
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/js/components/AppToggle.vue